import { IPaginatedResponse, IResponse, ISearchRequest } from "..";
import client from "../client";

export interface IFeature {
  id: string;
  name: string;
  description: string;
}

async function getUserFeatures(userId: string) {
  return client.get<IResponse<IFeature[]>>(`/feature/user:${userId}`);
}

async function addFeature(name: string) {
  return client.post<IResponse<IFeature>>(`/feature`, { name });
}

async function enableFeatureForUser(featureId: string, userId: string) {
  return client.post<IResponse<IFeature>>(
    `/feature/${featureId}/user/${userId}`,
    {}
  );
}

async function disableFeatureForUser(featureId: string, userId: string) {
  return client.delete<IResponse<IFeature>>(
    `/feature/${featureId}/user/${userId}`,
    {}
  );
}

async function searchFeatures(req: ISearchRequest) {
  return client.post<IPaginatedResponse<IFeature[]>>("/feature/search", req);
}

const api = {
  getUserFeatures,
  addFeature,
  searchFeatures,
  enableFeatureForUser,
  disableFeatureForUser,
};

export default api;
